export default {
      id: "ic_call_customer_service-usage",
      viewBox: "0 0 30 28",
      url: "/" + "images/icons.3.109.2.svg#ic_call_customer_service-usage",
      toString: function () {
        return this.url;
      }
    }